import { useParams } from 'react-router';

import { WooCommerceStep1, WooCommerceStep2 } from './WooCommerceSteps';
import { useGetIwocapayIntegrationInterest } from '../../../../api/lending/lapiHooks';
import externalLinkSVG from '../../../../assets/externalLink.svg';
import tickSVG from '../../assets/tick.svg';
import { useGetIntegrationStatus } from '../../hooks/useGetIntegrationStatus.hook';
import { WooCommerce } from '../../Integrations';
import { IntegrationsTitle } from '../IntegrationsTitle/IntegrationsTitle';
import { RegisterInterestButton } from '../RegisterInterestButton/RegisterInterestButton';

export function WooCommerceBody() {
  const { integrationParam } = useParams();

  const { integrationStatus } = useGetIntegrationStatus({
    integrationId: WooCommerce.id,
  });
  const isConnected = integrationStatus === 'CONNECTED';

  const { iwocapayIntegrationInterest, loadingIwocapayIntegrationInterest } =
    useGetIwocapayIntegrationInterest();
  const interestRegistered =
    WooCommerce.id && iwocapayIntegrationInterest?.includes(WooCommerce.id);

  const userHasInteracted = isConnected || interestRegistered;

  if (integrationParam !== WooCommerce.id) {
    return null;
  }
  if (loadingIwocapayIntegrationInterest) {
    return null;
  }
  return (
    <div className="text-left">
      <div className="flex flex-wrap items-center justify-between max-800:flex-col max-800:items-start max-800:pt-[2.25rem]">
        <IntegrationsTitle integration={WooCommerce} />
        <div className="max-800:w-full max-800:pt-l">
          {userHasInteracted && (
            <div className="text-m font-bold text-success-drk">
              <img src={tickSVG} alt="Tick Icon" className="pr-[0.7rem]" />
              {!isConnected && 'Request sent'}
              {isConnected && 'Connected'}
            </div>
          )}
          <RegisterInterestButton integrationName={WooCommerce.id} />
        </div>
      </div>
      <div className="border-b border-structure-80 pb-[3rem] text-m font-reg">
        <div>
          {!userHasInteracted && (
            <p>
              A fully customizable, open-source ecommerce platform built on
              WordPress. Build exactly the ecommerce site you want for yourself,
              or others.
              <br />
              <br />
              <b>
                When you connect iwocaPay to WooCommerce it'll automatically:
              </b>
              <ul>
                <li>
                  add iwocaPay as a payment method on your WooCommerce checkout
                </li>
                <li>
                  reconcile all iwocaPay payments with your WooCommerce store
                  data.
                </li>
              </ul>
            </p>
          )}
          {userHasInteracted && (
            <div>
              <p>
                <b>We’ve got your request to access the WooCommerce plugin.</b>
                <br />
                Not long now till you’ve added iwocaPay to your store checkout.
                <br />
                <br />
                Here’s what happens next:
              </p>
              <div className="mt-[2rem] border-t border-structure-80 pt-l">
                <WooCommerceStep1 />
                <WooCommerceStep2 />
              </div>
            </div>
          )}

          <div>
            <a
              href={
                'https://ecommerce-api.iwoca.com/guides/plugin-solution/woocommerce/'
              }
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center pt-[1.25rem] text-m font-bold text-primary-40 no-underline"
            >
              WooCommerce FAQs
              <img
                src={externalLinkSVG}
                alt="External Link Icon"
                className="pl-s"
              />
            </a>
          </div>
        </div>
      </div>
      <div className="inline-flex pt-[3rem] max-800:block max-800:w-full">
        <RegisterInterestButton integrationName={WooCommerce.id} />
      </div>
    </div>
  );
}
